import {
  Grid,
  Typography,
} from '@mui/material';
//

export const RetailerInfoField = ({
  label,
  value,
  size = { xs: 12, sm: 6, md: 4 },
  valueColor,
}) => {
  if (value == null || value === '') return null;
  return (
    <Grid size={size}>
      <Typography
        variant='caption'
        color='text.secondary'
        display='block'
        sx={{ mb: 0.25, textTransform: 'uppercase', letterSpacing: 0.4 }}
      >
        {label}
      </Typography>
      <Typography
        variant='body2'
        sx={{
          fontFamily: 'BrightstarSans-Bold',
          color: valueColor || 'var(--reach-blue)',
        }}
      >
        {value}
      </Typography>
    </Grid>
  );
};